var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-gamburger",
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#2C2F32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 14,
    x2: 21,
    y2: 14,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 31,
    y2: 20,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 26,
    x2: 31,
    y2: 26,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-slider",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#ED7E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18L18 10L19.425 11.4L13.825 17L26 17L26 19L13.825 19L19.425 24.6L18 26L10 18Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-slider-right",
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#ED7E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 20.9999L21 30.3333L19.3375 28.6999L25.8708 22.1666L11.6666 22.1666L11.6666 19.8333L25.8708 19.8333L19.3375 13.2999L21 11.6666L30.3333 20.9999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-twitter",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#ED7E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46 12C27.69 12.35 26.86 12.58 26 12.69C26.88 12.16 27.56 11.32 27.88 10.31C27.05 10.81 26.13 11.16 25.16 11.36C24.37 10.5 23.26 10 22 10C19.65 10 17.73 11.92 17.73 14.29C17.73 14.63 17.77 14.96 17.84 15.27C14.28 15.09 11.11 13.38 9.00004 10.79C8.63004 11.42 8.42004 12.16 8.42004 12.94C8.42004 14.43 9.17004 15.75 10.33 16.5C9.62004 16.5 8.96004 16.3 8.38004 16V16.03C8.38004 18.11 9.86004 19.85 11.82 20.24C11.1908 20.4122 10.5301 20.4362 9.89004 20.31C10.1616 21.1625 10.6936 21.9084 11.4111 22.4429C12.1285 22.9775 12.9955 23.2737 13.89 23.29C12.3737 24.4904 10.494 25.1393 8.56004 25.13C8.22004 25.13 7.88004 25.11 7.54004 25.07C9.44004 26.29 11.7 27 14.12 27C22 27 26.33 20.46 26.33 14.79C26.33 14.6 26.33 14.42 26.32 14.23C27.16 13.63 27.88 12.87 28.46 12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-linkedin",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#ED7E41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.429 14.969H19.143V16.819C19.678 15.755 21.05 14.799 23.111 14.799C27.062 14.799 28 16.917 28 20.803V28H24V21.688C24 19.475 23.465 18.227 22.103 18.227C20.214 18.227 19.429 19.572 19.429 21.687V28H15.429V14.969ZM8.57 27.83H12.57V14.799H8.57V27.83ZM13.143 10.55C13.1431 10.8853 13.0767 11.2172 12.9474 11.5266C12.8181 11.8359 12.6287 12.1165 12.39 12.352C11.9064 12.8326 11.2518 13.1017 10.57 13.1C9.88939 13.0995 9.23631 12.8312 8.752 12.353C8.51421 12.1167 8.32539 11.8358 8.19634 11.5264C8.0673 11.217 8.00058 10.8852 8 10.55C8 9.873 8.27 9.225 8.753 8.747C9.23689 8.26816 9.89024 7.9997 10.571 8C11.253 8 11.907 8.269 12.39 8.747C12.872 9.225 13.143 9.873 13.143 10.55Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#ED7E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5H22.5L23.5 15.5H20V13.5C20 12.47 20 11.5 22 11.5H23.5V8.14C23.174 8.097 21.943 8 20.643 8C17.928 8 16 9.657 16 12.7V15.5H13V19.5H16V28H20V19.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-geo",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0098 1.5C9.82249 1.50248 7.72551 2.37247 6.17888 3.91911C4.63224 5.46575 3.76225 7.56273 3.75977 9.75C3.75977 16.8094 11.2598 22.1437 11.5785 22.3687C11.7063 22.4538 11.8563 22.4992 12.0098 22.4992C12.1632 22.4992 12.3133 22.4538 12.441 22.3687C12.7598 22.1437 20.2598 16.8094 20.2598 9.75C20.2573 7.56273 19.3873 5.46575 17.8407 3.91911C16.294 2.37247 14.197 1.50248 12.0098 1.5ZM12.0098 6.75C12.6031 6.75 13.1831 6.92595 13.6765 7.25559C14.1698 7.58524 14.5543 8.05377 14.7814 8.60195C15.0085 9.15013 15.0679 9.75333 14.9521 10.3353C14.8364 10.9172 14.5506 11.4518 14.1311 11.8713C13.7115 12.2909 13.177 12.5766 12.595 12.6924C12.0131 12.8081 11.4099 12.7487 10.8617 12.5216C10.3135 12.2946 9.845 11.9101 9.51536 11.4167C9.18571 10.9234 9.00977 10.3433 9.00977 9.75C9.00977 8.95435 9.32584 8.19129 9.88844 7.62868C10.4511 7.06607 11.2141 6.75 12.0098 6.75Z",
    fill: "#ED7E41"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-phone",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1H7.5C6.83696 1 6.20107 1.26339 5.73223 1.73223C5.26339 2.20107 5 2.83696 5 3.5V20.5C5 21.163 5.26339 21.7989 5.73223 22.2678C6.20107 22.7366 6.83696 23 7.5 23H15.5C16.163 23 16.7989 22.7366 17.2678 22.2678C17.7366 21.7989 18 21.163 18 20.5V3.5C18 2.83696 17.7366 2.20107 17.2678 1.73223C16.7989 1.26339 16.163 1 15.5 1ZM11.5 22C10.67 22 10 21.33 10 20.5C10 19.67 10.67 19 11.5 19C12.33 19 13 19.67 13 20.5C13 21.33 12.33 22 11.5 22ZM16 18H7V4H16V18Z",
    fill: "#ED7E41"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.564 5.51C2.39601 3.85324 3.67237 2.46051 5.25043 1.48747C6.82849 0.514427 8.64606 -0.000583569 10.5 4.96231e-07C13.195 4.96231e-07 15.459 0.99 17.19 2.605L14.323 5.473C13.286 4.482 11.968 3.977 10.5 3.977C7.895 3.977 5.69 5.737 4.905 8.1C4.705 8.7 4.591 9.34 4.591 10C4.591 10.66 4.705 11.3 4.905 11.9C5.691 14.264 7.895 16.023 10.5 16.023C11.845 16.023 12.99 15.668 13.886 15.068C14.4054 14.726 14.8501 14.2822 15.1932 13.7635C15.5363 13.2448 15.7706 12.6619 15.882 12.05H10.5V8.182H19.918C20.036 8.836 20.1 9.518 20.1 10.227C20.1 13.273 19.01 15.837 17.118 17.577C15.464 19.105 13.2 20 10.5 20C9.18663 20.0005 7.88604 19.7422 6.67254 19.2399C5.45905 18.7375 4.35645 18.0009 3.42776 17.0722C2.49907 16.1436 1.7625 15.041 1.26013 13.8275C0.757774 12.614 0.499475 11.3134 0.500001 10C0.500001 8.386 0.886001 6.86 1.564 5.51Z",
    fill: "#ED7E41"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.571429,
    y: 0.571429,
    width: 46.8571,
    height: 46.8571,
    rx: 5.42857,
    fill: "#2C2F32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.8571,
    y: 14.8571,
    width: 2.28571,
    height: 22.8571,
    transform: "rotate(45 30.8571 14.8571)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4733,
    y: 31.0196,
    width: 2.28571,
    height: 22.8571,
    transform: "rotate(135 32.4733 31.0196)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.571429,
    y: 0.571429,
    width: 46.8571,
    height: 46.8571,
    rx: 5.42857,
    stroke: "#6D757D",
    strokeWidth: 1.14286
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dropdown",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#2C2F32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 18L18 26L16.575 24.6L22.175 19L10 19L10 17L22.175 17L16.575 11.4L18 10L26 18Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-slider-black",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#FF9C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18L18 10L19.425 11.4L13.825 17L26 17L26 19L13.825 19L19.425 24.6L18 26L10 18Z",
    fill: "#0B0C0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/Icons.08ec858b99b39a396e832051764ac0c5.svg";
export { ForwardRef as ReactComponent };